import React, { Component, useEffect, useRef, useState } from "react";
import { toast } from "../../utils/helpers";

const FotoField = ({foto: fotoOriginal, name, fotoCed, readOnly}) => {
    const [foto, setFoto] = useState(fotoOriginal || false);
    const fotoRef = useRef();

    const onChangeFoto = (e) => {
        const file = e.target.files[0];
        console.log(file.size)
        if (file.size > (1024 * 1) * 1024) {
            toast('El tamaño del archivo no debe exceder 1MB', 'error');
            return false;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            setFoto(e.target.result);
        };

        if (file) {
            reader.readAsDataURL(file);
        } else {
            setFoto(false);
        }
    };

    const removeFoto = () => {
        fotoRef.current.value = null;
        setFoto(false);
    };

    useEffect(() => {
        setFoto(fotoOriginal);
    }, [fotoOriginal])

    return (
        <div className='foto-container'>
            {!fotoCed && (
                <div>
                    {!readOnly && <input
                        name={name}
                        type='file'
                        style={{
                            display: foto ? "none" : "block",
                        }}
                        ref={fotoRef}
                        accept='image/png, image/jpeg'
                        onChange={onChangeFoto}
                    />}
                    {foto && <img src={foto} alt='Foto' />}
                </div>
            )}
            {fotoCed && (
                <div>
                    {!readOnly && <input type='hidden' name='fotoCed' value={fotoCed} />}
                    <img
                        src={`data:image/jpeg;base64,${fotoCed}`}
                        alt={name}
                    />
                </div>
            )}
            {foto && (
                <div>
                    {!readOnly && <input
                        type='hidden'
                        name={`${name}`}
                        value={foto ? foto : ""}
                    />}
                </div>
            )}
            {foto && !readOnly && (
                <button type='button' onClick={removeFoto}>
                    X
                </button>
            )}
        </div>
    );
}

export default FotoField;
